// extracted by mini-css-extract-plugin
module.exports = {"input":"KnowledgeBaseEdit_input__3ySVU","editorWrapper":"KnowledgeBaseEdit_editorWrapper__3iWj0"};